var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-i"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"full-chat-w"},[_c('div',{staticClass:"full-chat-i"},[_c('div',{staticClass:"full-chat-left scrollable"},[_c('StatementRail',{attrs:{"statements":_vm.statements}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }